import Vue from 'vue';
import Vuex from 'vuex';
// 如果需要使用 axios 模块进行异步请求需要先导入
import axios from 'axios';
import _ from 'lodash';
import { db, auth } from './firebase.js';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    account: 'Ben',
    searchKey: '',
    focusId: '',
    articles: [],
    message: '',
    isLogin: false,
  },
  mutations: {
    GET_ARTICLES(state, payload) {
      // payload.sort((a, b) => {
      //   return a.date < b.date ? 1 : -1;
      // });
      state.articles = payload;
    },
    CHANGE_SEARCH_KEY(state, payload) {
      state.searchKey = payload;
    },
    LOGIN(state) {
      state.isLogin = true;
    },
    LOGOUT(state) {
      state.isLogin = false;
    },
    ADD_ARTICLE(state, payload) {
      // let idArr = state.articles.map(item => item.id);
      // let id = _.random(10000);
      // while (idArr.includes(id)) {
      //   id = _.random(10000);
      // }
      // payload.id = id;
      state.articles = [payload, ...state.articles];
      state.changeArticle = !state.changeArticle;
    },
    CHANGE_FOCUS_ID(state, payload) {
      state.focusId = payload;
    },
    CLEAR_FILTER_ID(state) {
      state.focusId = '';
    },
    UPDATE_ARTICLE(state, {
      id,
      newArticle
    }) {
      let idArr = state.articles.map(item => item.id);
      let index = idArr.indexOf(id);
      state.articles[index] = {
        id: id,
        ...newArticle
      };
      state.changeArticle = !state.changeArticle;
    },
    DEL_ARTICLE(state, payload) {
      let idArr = state.articles.map(item => item.id);
      let index = idArr.indexOf(payload);
      state.articles.splice(index, 1);
    }
  },
  actions: {
    getArticles(context) {
      // const api =
      //   "https://us-central1-expressapi-8c039.cloudfunctions.net/app/article";
      // axios.get(api).then(response => {
      //   let articles = response.data.data;
      //   context.commit('GET_ARTICLES', articles);
      // });
      // console.log(db);
      const Ref = db.collection('Articles');
      Ref.get().then((response) => {
          let payload = [];
          response.forEach(item => {
            payload.push({
              id: item.id,
              ...item.data()
            });
          });
          context.commit('GET_ARTICLES', payload);
        })
        .catch((error) => {
          context.state.message = {
            content: `获取文章列表失败：${error.message}`,
            done: '失败',
            variant: 'danger'
          };
        });
    },
    changeSearchKey(context, payload) {
      context.commit('CHANGE_SEARCH_KEY', payload);
    },
    login: async (context, payload) => {
      try {
        await auth.signInWithEmailAndPassword(payload.account, payload.password).then((response) => {
          let user = response.user;
          context.commit('LOGIN');
          context.state.message = {
            content: `${user.email}登陆成功`,
            done: '成功',
            variant: 'success'
          };
        })
      } catch (error) {
        context.state.message = {
          content: `登陆失败：${error.message}`,
          done: '失败',
          variant: 'danger'
        };
      }
    },
    logout: async (context, payload) => {
      try {
        await auth.signOut().then(() => {
          context.commit('LOGOUT')
          context.state.message = {
            content: `登出成功`,
            done: '成功',
            variant: 'success'
          };
        })
      } catch (error) {
        context.state.message = {
          content: `登出失败：${error.message}`,
          done: '失败',
          variant: 'danger'
        };
      }
    },
    addArticle: async (context, payload) => {
      const Ref = db.collection('Articles');
      try {
        await Ref.add(payload)
          .then(response => {
            context.commit('ADD_ARTICLE', {
              id: response.id,
              ...payload
            });
            context.state.message = {
              content: `文章《${payload.title}》新增成功`,
              done: '成功',
              variant: 'success'
            };
          })
      } catch (error) {
        context.state.message = {
          content: `添加文章失败：${error}`,
          done: '失败',
          variant: 'danger'
        };
      }
    },
    changeFocusId(context, payload) {
      context.commit('CHANGE_FOCUS_ID', payload);
    },
    clearFilterId(context) {
      context.commit('CLEAR_FILTER_ID');
    },
    updateArticle: async (context, payload) => {
      const docRef = db.collection('Articles').doc(payload.id);
      try {
        await docRef.update(payload.newArticle)
          .then(() => {
            context.commit('UPDATE_ARTICLE', payload);
          });
        context.state.message = {
          content: `文章《${payload.newArticle.title}》更新成功`,
          done: '成功',
          variant: 'success'
        };
      } catch (error) {
        context.state.message = {
          content: `文章更新失败：${error}`,
          done: '失败',
          variant: 'danger'
        };
      }
    },
    delArticle: async (context, payload) => {
      const docRef = db.collection('Articles').doc(payload);
      try {
        await docRef.delete().then(() => {
          context.commit('DEL_ARTICLE', payload);
        })
        context.state.message = {
          content: `文章删除成功`,
          done: '成功',
          variant: 'success'
        };
      } catch (error) {
        context.state.message = {
          content: `文章删除失败：${error}`,
          done: '失败',
          variant: 'danger'
        };
      }
    }
  },
  getters: {
    filterByKey(state) {
      if (!state.searchKey) {
        return state.articles;
      } else {
        return state.articles.filter(item => {
          return item.title.includes(state.searchKey) || item.content.includes(state.searchKey);
        })
      }
    },
    filterById(state) {
      return state.articles.find(item => item.id === state.focusId);
    }
  }
})